import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { SignInNoteDescription } from '~src/authentication/components/loginSpace/SignInNoteDescription';
import { Messages } from '~src/codegen/Localize';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { SignInErrorMessageMapper } from '../services/SignInErrorMessageMapper';
import { KbArticleLink } from './KbArticleLink';

export interface SignoutErrorProps {
  redirectPath?: string;
  errorCode: string;
}

const signInNoteDescriptionProps = {
  signInNoteContainerStyleOverride: {
    marginTop: '12px',
    minHeight: '0px'
  }
};

const buttonStyle: React.CSSProperties = {
  marginTop: CommonStyles.Sizes.XLargeSpace - CommonStyles.Sizes.DefaultSpace,
};

export function SigninErrorPage(props: SignoutErrorProps) {

  const errorCode = Number(props.errorCode);

  function tryAgain() {
    WindowLocationService.setPathQueryFragment(props.redirectPath);
  }

  return (
    <div className="tb-error-box">
      <div role="alert" aria-atomic="true">
        <div className="tb-padded tb-login-title">{Messages.signinErrorHeading()}</div>
        <div className="tb-error-box-message">
          <div>{SignInErrorMessageMapper.getErrorMessageFor(errorCode)}</div>
          <div>{SignInErrorMessageMapper.getFollowUpActionMessageFor(errorCode)}</div>
          <KbArticleLink pageId={SignInErrorMessageMapper.getKbArticleIdFor(errorCode)} />
          <SignInNoteDescription {...signInNoteDescriptionProps} />
        </div>
      </div>
      <ButtonWidget buttonType={ButtonType.Outline}
        style={buttonStyle}
        onClick={() => tryAgain()}
        testId="try-again">
        {Messages.tryAgain()}
      </ButtonWidget>
    </div>
  );
}
